<template>
  <pdfs-clinical-page v-if="!administrator" :selectedPdf="selectedPdf" />
  <pdfs-provider-documents v-else />
</template>

<script>
import { mapGetters } from 'vuex';
import { getAdministrator } from '@/data/getters';
import PdfsClinicalPage from '@/components/private-layouts/PdfsClinicalPage.vue';
import PdfsProviderDocuments from '@/components/private-layouts/PdfsProviderDocuments.vue';

export default {
  name: 'pdf-page',
  components: {
    PdfsClinicalPage,
    PdfsProviderDocuments,
  },
  props: {
    selectedPdf: {
      type: Number,
      required: false,
    },
  },
  computed: {
    ...mapGetters('login', {
      allData: 'getAllData',
    }),
    administrator() {
      return getAdministrator(this.allData);
    },
  },
};
</script>
